// @flow

import React from 'react';
import { Icon } from '@ta/styleguide.icon';
import classnames from '@ta/common.classnames';
import { ProtectedObfuscatedLink } from '@ta/social.obfuscation';
import { InteractionLogger } from '@ta/tracking.interactions';
import { getPhoto, truncateLinkInfo } from './shared';

import styles from './DmoLinkPost.less';

const maxTitleChar = 105;
const maxDescriptionChar = 150;

const ExternalLink = ({ urlDomain }) => (
  <span className={styles.urlWrapper}>
    <p className={classnames('ui_link', styles.url)}>{urlDomain}</p>
    <Icon name="external-link-no-box" className={styles.icon} />
  </span>
);

const DmoLinkPost = ({ content }: { content: any }) => {
  const LinkPost = (
    <div className={styles.linkMainContainer}>
      {content?.preview?.media?.[0] && (
        <div className={styles.linkPhotoContainer}>
          {getPhoto(content?.preview?.media?.[0], styles.placeholder, null)}
        </div>
      )}
      <div className={styles.linkDetailsContainer}>
        {content?.preview?.title?.length > 0 && (
          <div className={classnames('ui_link', styles.linkTitleContainer)}>
            {truncateLinkInfo(content?.preview.title, maxTitleChar)}
          </div>
        )}
        {content?.preview?.description?.length > 0 && !content?.preview?.media?.[0] && (
          <p className={`ui_link ${styles.description}`}>
            {truncateLinkInfo(content?.preview.description, maxDescriptionChar)}
          </p>
        )}
        <ExternalLink urlDomain={content?.preview.urlDomain} />
      </div>
    </div>
  );

  const trackingParams = {
    contentType: 'LINK_POST',
    contentId: content.postId,
    sponsoredBy: content.userProfile.userId,
  };

  return (
    <InteractionLogger>
      {logInteraction => (
        <ProtectedObfuscatedLink
          className={styles.clickable}
          target="_blank"
          onClick={e => {
            logInteraction(e, 'rightRailDestinationSpotlightClick', trackingParams);
          }}
          encodedUrl={content?.preview?.canonicalUrl}
        >
          {LinkPost}
        </ProtectedObfuscatedLink>
      )}
    </InteractionLogger>
  );
};

export default DmoLinkPost;
